import React from 'react';

const AnalyzeReports = () => <h1 className="pageTitle">Reports</h1>;

export default AnalyzeReports;
